export default {"src":"/_next/static/media/close-circle-svgrepo-com (1).2f0fe90d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};